import React from 'react';
// import TextEditor from '../../TextEditor';
import {observer, inject} from 'mobx-react';
import FilePreview from './FilePreview';
import {TARGET_FILE_CONTENT_TYPES, TARGET_FILE_MAX_SIZE} from '../../constants';
import _ from 'lodash';
import classNames from 'classnames';
import QuillEditor from '../../QuillEditor';

@inject('onlineWorkshop')
@inject('alert')
@inject('deleteModal')
@observer
export default class QuestionContent extends React.Component {

  constructor(props){
    super(props);
    this.key = 1000;
  }

  handleChange = data => {
    this.props.onlineWorkshop.handleChangeQuestion(this.props.moduleIndex, this.props.questionIndex, {text: data })
  };


  deleteFile = data => {
    let currentWorkShop = this.props.onlineWorkshop.modules[this.props.moduleIndex].questions_attributes[this.props.questionIndex];
    let fileIndex = _.findIndex(currentWorkShop.attachments_attributes, el => el.key === data);

    if(currentWorkShop.attachments_attributes[fileIndex].id){
      this.props.deleteModal.eventDelete({
        type: 'file',
        fileTo: 'question',
        fileId: currentWorkShop.attachments_attributes[fileIndex].id,
        modal: this.props.moduleIndex,
        question: this.props.questionIndex,
        file: fileIndex
      })
    }
    else
      this.props.onlineWorkshop.deleteQuestionFile(this.props.moduleIndex, this.props.questionIndex, fileIndex)
  };

  addFile = e => {
    let file = e.target.files[0];
    if(file.size > TARGET_FILE_MAX_SIZE || !TARGET_FILE_CONTENT_TYPES.includes(file.type)){
      this.props.alert.error('File is too big or content type is not correct')
    }
    else {
      if (e.target.files && e.target.files[0]) {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onload = e => {
          this.key++;
          let newFile = _.assign({
            document: file,
            file_name: file.name,
            file_size: file.size,
            key: this.key
          });
          this.props.onlineWorkshop.addQuestionFile(this.props.moduleIndex,this.props.questionIndex, newFile)
        };
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };

  render(){
    const EMPTY_FILE = (
      <label>
        <li className="file-item">
          <div className="file-item-inner">
            <i className="ic-upload-ico file-icon"/>
            <div className='file-link'>
              <p className="file-link-size">Formats allowed:</p>
              <p className="file-link-size">PDF, Word (Max size 5MB)</p>
            </div>
          </div>
          <input type="file" style={{display: 'none'}} onChange={this.addFile}/>
        </li>
      </label>);

      let currentQuestion = this.props.onlineWorkshop.modules[this.props.moduleIndex].questions_attributes[this.props.questionIndex];
    let currentErrors;
    if(this.props.onlineWorkshop.modulesError.length - 1 < this.props.moduleIndex)
      currentErrors = {};
    else
      if(this.props.onlineWorkshop.modulesError[this.props.moduleIndex].questionError.length - 1 < [this.props.questionIndex])
        currentErrors = {};
      else
        currentErrors = this.props.onlineWorkshop.modulesError[this.props.moduleIndex].questionError[this.props.questionIndex];
    return(
      <div className="question-accordion-content">
        <div className="question-accordion-content-holder">
      <div className="row">
        <div className={classNames({'col-12': true, 'has-error': currentErrors.text }) }>
          <div className="accordion-content-block">

            <QuillEditor
              showToolbar={true}
              onChange={this.handleChange}
              value={currentQuestion.text}
              placeholder={'Ask your question'}
            />

            {/* <TextEditor description={currentQuestion.text}
                        onChange={this.handleChange}
                        moduleId={this.props.moduleIndex}
                        placeholder="Ask your question"
                        type="question"
            id={this.props.questionIndex}/> */}

            <span className="error-text" style={{color: '#e91e63'}}>{currentErrors.text}</span>
            <div className="border"/>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="accordion-content-block">
            <p className="label">Upload Up to 3 Files</p>
            <ul className="file-list editing">
              {
                currentQuestion.attachments_attributes.map( el =>
                  <FilePreview el={el} key={el.key} deleteFile={this.deleteFile}/>)
              }
              { currentQuestion.attachments_attributes.length >= 3 || EMPTY_FILE }

            </ul>
          </div>
        </div>
      </div>
    </div>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/create_workshop/create_module/create_question/QuestionContent.jsx